import { Component, h, Host, Prop, Element, Watch } from '@stencil/core';
import { createStyles } from './content-wrapper-styles';
import { injectCSS } from '../../utils';
import {
  TContentWidth,
  TContentSlant,
  TContentBackgroundColor,
  TContentBackgroundFull,
} from './content-wrapper-utils';

@Component({
  tag: 'dc-ui-content-wrapper',
  shadow: true,
})
export class DcUiContentWrapper {
  @Element() host!: HTMLElement;
  @Prop() width: TContentWidth = 'basic';
  @Prop() backgroundColor?: TContentBackgroundColor;
  @Prop() backgroundFull: TContentBackgroundFull;
  @Prop() slant?: TContentSlant;

  @Watch('slant')
  checkIfSlant() {
    if (this.slant) {
      this.backgroundFull = true;
    }
  }

  componentWillLoad() {
    this.checkIfSlant();
  }

  render() {
    injectCSS(this.host, createStyles, this.width, this.backgroundColor, this.backgroundFull);

    return (
      <Host>
        {((this.slant && this.slant === 'both') || this.slant === 'top') && (
          <div class="dc-ui-slant dc-ui-slant--top">
            <span></span>
          </div>
        )}

        <div
          class={`
          dc-ui-content-wrapper
          ${this.backgroundFull || this.slant ? 'dc-ui-content-wrapper--background-full' : ''}
        `}>
          <slot />
        </div>

        {((this.slant && this.slant === 'both') || this.slant === 'bottom') && (
          <div class="dc-ui-slant dc-ui-slant--bottom">
            <span></span>
          </div>
        )}
      </Host>
    );
  }
}
